// extracted by mini-css-extract-plugin
module.exports = {"noFavePayCard":"FavePayView_noFavePayCard__3uvtF","favePayInfoIcon":"FavePayView_favePayInfoIcon__2XoFO","bottomButton":"FavePayView_bottomButton__272CB"};